import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './parenting.json';

const Parenting = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Parenting styles, child development, and family vocabulary. B2 level English exercises with grammar, reading, and discussion."
            level="B2"
            title="Parenting"
            image="/Images/parents1.webp"
            seoTitle="Free English Lesson Plans: Parenting"
            seoDescription="Parenting styles, child development, and family vocabulary. B2 level English exercises with grammar, reading, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Parenting;


